export type Language = 'EN' | 'KOR' | 'CHN';

export const translations = {
    EN: {
        meta: {
            lang: 'en',
            title: "Sakura-an | Men's Oil Massage Spa in Osaka Namba",
            description: "Osaka Namba's top men's spa. Full-body oil & aromatherapy massage in private rooms with shower. 7 min walk from Namba Station. English support. Book via LINE or WhatsApp.",
            ogTitle: "Sakura-an | Men's Oil Massage Spa – Osaka Namba",
            ogDescription: "Relieve travel fatigue with full-body oil massage in private rooms. English support, 7 min from Namba Station. Book via LINE or WhatsApp."
        },
        nav: {
            experience: "Experience",
            menu: "Menu",
            therapists: "Therapists",
            access: "Access",
            bookNow: "Book Now"
        },
        hero: {
            tag: "Premium Men's Esthe in Osaka",
            title: "The Ultimate Japanese\nHealing Experience in Osaka",
            subtitle: "Relieve your travel fatigue with our premium oil massage",
            bookNow: "Book Now",
            viewMenu: "View Menu"
        },
        concept: {
            tag: "Our Philosophy",
            title: "Japanese Omotenashi",
            subtitle: "Experience authentic hospitality with every detail",
            rooms: {
                title: "Private Rooms",
                desc: "Fully private treatment rooms with traditional Japanese aesthetics. Shower facilities available for your comfort."
            },
            staff: {
                title: "Professional Therapists",
                desc: "Our carefully selected therapists combine technical expertise with warm Japanese hospitality."
            },
            atmosphere: {
                title: "Authentic Atmosphere",
                desc: "Immerse yourself in a serene environment featuring natural wood, soft lighting, and subtle sakura accents."
            },
            features: [
                "English Support Available",
                "No Hidden Fees",
                "Tourist Friendly"
            ]
        },
        menu: {
            tag: "Our Courses",
            title: "Choose Your Perfect Experience",
            subtitle: "All courses include premium aromatherapy oil massage",
            select: "Select Course",
            popular: "Most Popular",
            courses: {
                c90: {
                    title: "90min",
                    service: "Oil Massage",
                    features: ["Full Body Oil Massage", "Private Room & Shower"]
                },
                c100: {
                    title: "100min",
                    service: "Wash + Oil Massage",
                    features: ["Foam Body Wash", "Full Body Oil Massage", "Refreshing Experience"]
                },
                c120: {
                    title: "120min",
                    service: "Premium Wash + Massage",
                    features: ["Long Foam Body Wash", "Deep Relax Oil Massage", "Ultimate Satisfaction"]
                }
            }
        },
        therapists: {
            title: "Meet Our Therapists",
            subtitle: "Professional, friendly, and dedicated to your comfort",
            nominationFee: "Therapist nomination fee: ¥1,000"
        },
        access: {
            tag: "Easy Access",
            title: "Access from Namba",
            namba: "7 min walk Namba Station",
            nipponbashi: "5 min walk Nihonbashi Station",
            dotonbori: "3 min walk Dotonbori",
            openInMaps: "Open in Google Maps"
        },
        booking: {
            title: "Ready to Experience Sakura-an?",
            subtitle: "Book your appointment now. English support available.",
            secure: "Secure Booking",
            instant: "Instant Confirmation",
            support: "English Support"
        },
        disclaimer: {
            line1: "Professional Relaxation Massage",
            line2: "No Sexual Services"
        },
        footer: {
            tag: "Premium Japanese Men's Esthe in Osaka",
            quickLinks: "Quick Links",
            contact: "Contact",
            openDaily: "Open Daily"
        }
    },
    KOR: {
        meta: {
            lang: 'ko',
            title: "오사카 난바 오일마사지 전문점 | 咲くら庵 맨즈 에스테・한국어 대응",
            description: "오사카 난바역 도보 7분. 전문 테라피스트의 프리미엄 아로마 오일 마사지. 완전 개인실・샤워 완비. 카카오톡으로 간단 예약. 한국어 대응 완비.",
            ogTitle: "오사카 난바 오일마사지 | 咲くら庵 맨즈 에스테",
            ogDescription: "오사카 난바의 오일마사지 전문 맨즈 에스테. 전문 테라피스트, 완전 개인실, 한국어 대응. 난바역 도보 7분. 카카오톡으로 예약 가능."
        },
        nav: {
            experience: "체험",
            menu: "메뉴",
            therapists: "테라피스트",
            access: "오시는 길",
            bookNow: "예약하기"
        },
        hero: {
            tag: "오사카 프리미엄 맨즈 에스테",
            title: "오사카에서 즐기는\n최고의 일본식 힐링 경험",
            subtitle: "프리미엄 오일 마사지로 여행의 피로를 풀어보세요",
            bookNow: "예약하기",
            viewMenu: "메뉴 보기"
        },
        concept: {
            tag: "우리의 철학",
            title: "일본식 오모테나시",
            subtitle: "세심한 배려가 담긴 진정한 환대를 경험해 보세요",
            rooms: {
                title: "프라이빗 룸",
                desc: "전통적인 일본 미학을 담은 완전 개인실입니다. 편안함을 위한 샤워 시설이 완비되어 있습니다."
            },
            staff: {
                title: "전문 테라피스트",
                desc: "엄선된 테라피스트들이 전문적인 기술과 따뜻한 환대를 선사합니다."
            },
            atmosphere: {
                title: "전통적인 분위기",
                desc: "천연 목재, 은은한 조명, 섬세한 벚꽃 장식이 어우러진 평온한 공간입니다."
            },
            features: [
                "한국어/영어 대응 가능",
                "추가 요금 없음",
                "관광객 환영"
            ]
        },
        menu: {
            tag: "우리의 코스",
            title: "당신에게 완벽한 경험을 선택하세요",
            subtitle: "모든 코스에는 프리미엄 아로마 오일 마사지가 포함됩니다",
            select: "코스 선택",
            popular: "가장 인기 있는",
            courses: {
                c90: {
                    title: "90분",
                    service: "오일 마사지",
                    features: ["전신 오일 마사지", "개인실 및 샤워"]
                },
                c100: {
                    title: "100분",
                    service: "폼 바디워시 + 오일 마사지",
                    features: ["폼 바디워시", "전신 오일 마사지", "상쾌한 경험"]
                },
                c120: {
                    title: "120분",
                    service: "프리미엄 폼 바디워시 + 마사지",
                    features: ["롱 폼 바디워시", "딥 릴랙스 오일 마사지", "최고의 만족감"]
                }
            }
        },
        therapists: {
            title: "테라피스트 소개",
            subtitle: "당신의 편안함을 위해 헌신하는 전문적이고 친절한 스태프",
            nominationFee: "테라피스트 지명료: ¥1,000"
        },
        access: {
            tag: "편리한 접근성",
            title: "오시는 길",
            namba: "난바역 도보 7분",
            nipponbashi: "닛폰바시역 도보 5분",
            dotonbori: "도톤보리 도보 3분",
            openInMaps: "Google 지도에서 열기"
        },
        booking: {
            title: "사쿠라안을 경험할 준비가 되셨나요?",
            subtitle: "지금 예약하세요. 외국어 대응이 가능합니다.",
            secure: "보안 예약",
            instant: "즉시 확정",
            support: "외국어 지원"
        },
        disclaimer: {
            line1: "정식 힐링 마사지샵",
            line2: "성적 서비스 없음"
        },
        footer: {
            tag: "오사카 프리미엄 일본식 맨즈 에스테",
            quickLinks: "퀵 링크",
            contact: "연락처",
            openDaily: "매일 영업"
        }
    },
    CHN: {
        meta: {
            lang: 'zh',
            title: "咲くら庵 | 大阪难波高级男士精油按摩・男子美容",
            description: "在大阪难波体验极致的日式疗愈。专业理疗师的高级芳香精油按摩。独立包厢，配备淋浴。难波站步行7分钟。可通过微信（WeChat）预约。",
            ogTitle: "咲くら庵 | 大阪难波高级男士美容",
            ogDescription: "大阪精油按摩专门店。高级精油按摩缓解旅途疲劳。私密房间，提供中文支持，距难波站步行7分钟。"
        },
        nav: {
            experience: "体验",
            menu: "菜单",
            therapists: "理疗师",
            access: "位置",
            bookNow: "立即预约"
        },
        hero: {
            tag: "大阪高级男子美容",
            title: "在大阪享受\n极致的日式疗愈体验",
            subtitle: "专业的精油按摩，缓解您的旅途疲劳",
            bookNow: "立即预约",
            viewMenu: "查看菜单"
        },
        concept: {
            tag: "我们的理念",
            title: "日式款待 (Omotenashi)",
            subtitle: "从每一个细节中体验纯正的日式服务",
            rooms: {
                title: "私密房间",
                desc: "融合传统日式美学的全私密理疗室。配备淋浴设施，确保您的舒适体验。"
            },
            staff: {
                title: "专业理疗师",
                desc: "我们精心挑选的理疗师将专业技能与热情的日式服务相结合。"
            },
            atmosphere: {
                title: "纯正氛围",
                desc: "天然木材、柔和灯光和精致的樱花点缀，让您沉浸在宁静的环境中。"
            },
            features: [
                "提供中文/英文支持",
                "无隐藏费用",
                "欢迎游客"
            ]
        },
        menu: {
            tag: "我们的课程",
            title: "选择您的完美体验",
            subtitle: "所有课程均包含高级香薰精油按摩",
            select: "选择课程",
            popular: "最受欢迎",
            courses: {
                c90: {
                    title: "90分钟",
                    service: "精油按摩",
                    features: ["全身精油按摩", "私密房间与淋浴"]
                },
                c100: {
                    title: "100分钟",
                    service: "洗体 + 精油按摩",
                    features: ["泡沫洗体", "全身精油按摩", "清爽体验"]
                },
                c120: {
                    title: "120分钟",
                    service: "高级洗体 + 按摩",
                    features: ["加长洗体", "深层放松精油按摩", "极致满足感"]
                }
            }
        },
        therapists: {
            title: "理疗师团队",
            subtitle: "专业、友好，竭诚为您提供舒适服务",
            nominationFee: "理疗师指名费：¥1,000"
        },
        access: {
            tag: "交通便利",
            title: "地理位置",
            namba: "难波站 步行 7 分钟",
            nipponbashi: "日本桥站 步行 5 分钟",
            dotonbori: "道顿堀 步行 3 分钟",
            openInMaps: "在 Google 地图中打开"
        },
        booking: {
            title: "准备好体验 咲くら庵 了吗？",
            subtitle: "点击立即预约。提供中文/英文支持。",
            secure: "安全预约",
            instant: "即时确认",
            support: "外语支持"
        },
        disclaimer: {
            line1: "正规放松按摩店",
            line2: "不提供色情服务"
        },
        footer: {
            tag: "大阪高级日式男子美容",
            quickLinks: "快速链接",
            contact: "联系我们",
            openDaily: "每日营业"
        }
    }
};
